import { SafeHtml } from '@app/components/core/safeHtml/SafeHtml'
import { useQuery } from '@based/sdk/react'
import { LoomVideo } from '@app/components/core/LoomVideo/LoomVideo'
import { SlideShareEmbed } from '@app/components/core/SlideShareEmbed/SlideShareEmbed'
import { Title } from '@app/components/core/typography/Title'
import { Paragraph } from '@app/components/core/typography/Paragraph'
import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import type { ViewElearningItemModel } from 'functions/app/elearning-item/view'
import { Button } from '@app/components/core/button/Button'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const ElearningItemContent = ({ id }: { id: string }) => {
  const t = useTranslations().app.elearningPage
  const itemQuery = useQuery('view-elearning-item', { id })
  const item: ViewElearningItemModel | undefined = itemQuery.data
  const defaultDescription = (item?.description || item?.intro || '').trim()

  const handleDownloadPdf = () => {
    if (item?.pdf) {
      window.open(item.pdf.src, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <Column style={{ width: '100%' }} gap="3rem">
      {item?.title && (
        <PageSeo
          pageTitle={item.title}
          description={defaultDescription}
          meta={{
            metaTitle: item.metaTitle,
            metaDescription: item.metaDescription,
          }}
          image={item.images?.[0]}
        />
      )}
      <div style={{ width: '100%' }}>
        <Title.H1>{item?.title}</Title.H1>
        <SafeHtml html={item?.content ?? ''} />
        {item?.loomVideoShareUrl && (
          <LoomVideo src={item.loomVideoShareUrl} style={{ width: '100%' }} />
        )}
      </div>

      {item?.slideShareShareUrl && (
        <div>
          <Title.H3>{t.viewSlides}</Title.H3>
          <Paragraph.Medium>{t.viewSlidesDesc}</Paragraph.Medium>
          <SlideShareEmbed src={item.slideShareShareUrl} />
        </div>
      )}

      <div>
        <Title.H3>{t.assignments}</Title.H3>
        <Paragraph.Medium>{t.assignmentsDesc1}</Paragraph.Medium>
        <Paragraph.Medium>{t.assignmentsDesc2}</Paragraph.Medium>
        <Paragraph.Medium>{t.tip}</Paragraph.Medium>
        {item?.pdf && (
          <Button
            label={t.downloadPdfLabel}
            onClick={handleDownloadPdf}
            style={{ marginBottom: '2rem' }}
          />
        )}
      </div>
    </Column>
  )
}
